import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { cn } from '@/lib/styles';
import type { GridCardProps } from '@/types/general';
import type { ServerRenderedEntry } from '@/types/helpers';
import { AppsCard } from './variants/AppsCard';
import { CompetitorsCard } from './variants/CompetitorsCard';
import { FileFormatCard } from './variants/FileFormatCard';
import { IntegrationsCard } from './variants/IntegrationsCard';
import { IntegrationsWithDescriptionCard } from './variants/IntegrationsWithDescriptionCard';
export function Tile(props) {
  const $ = _c(31);
  let className;
  let t0;
  let tileParams;
  let variant;
  if ($[0] !== props) {
    ({
      variant,
      className,
      asLink: t0,
      ...tileParams
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = t0;
    $[3] = tileParams;
    $[4] = variant;
  } else {
    className = $[1];
    t0 = $[2];
    tileParams = $[3];
    variant = $[4];
  }
  const asLink = t0 === undefined ? true : t0;
  const hasLink = !!props.link?.href;
  let t1;
  let t2;
  let t3;
  let variantComponent;
  if ($[5] !== asLink || $[6] !== className || $[7] !== hasLink || $[8] !== props.link || $[9] !== tileParams || $[10] !== variant) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const commonClassName = cn("group focus:outline-none w-full flex rounded-xl border relative border-neutral-light-600 transition-colors duration-200 h-full items-baseline group-data-[state=active]:cursor-default", hasLink && "hover:border-brand-salmon focus-visible:border-brand-salmon active:bg-neutral-light-200 group-data-[state=active]:border-brand-salmon", asLink && !hasLink && "bg-neutral-light-300", className);
      bb1: switch (variant) {
        case "fileFormat":
          {
            let t4;
            if ($[15] !== tileParams) {
              t4 = <FileFormatCard {...tileParams} />;
              $[15] = tileParams;
              $[16] = t4;
            } else {
              t4 = $[16];
            }
            variantComponent = t4;
            break bb1;
          }
        case "competitors":
          {
            let t4;
            if ($[17] !== tileParams) {
              t4 = <CompetitorsCard {...tileParams} />;
              $[17] = tileParams;
              $[18] = t4;
            } else {
              t4 = $[18];
            }
            variantComponent = t4;
            break bb1;
          }
        case "integrations":
          {
            let t4;
            if ($[19] !== tileParams) {
              t4 = <IntegrationsCard {...tileParams} />;
              $[19] = tileParams;
              $[20] = t4;
            } else {
              t4 = $[20];
            }
            variantComponent = t4;
            break bb1;
          }
        case "integrationsWithDescription":
          {
            let t4;
            if ($[21] !== tileParams) {
              t4 = <IntegrationsWithDescriptionCard {...tileParams} />;
              $[21] = tileParams;
              $[22] = t4;
            } else {
              t4 = $[22];
            }
            variantComponent = t4;
            break bb1;
          }
        case "apps":
          {
            let t4;
            if ($[23] !== tileParams) {
              t4 = <AppsCard {...tileParams} />;
              $[23] = tileParams;
              $[24] = t4;
            } else {
              t4 = $[24];
            }
            variantComponent = t4;
            break bb1;
          }
        default:
          {
            variantComponent = null;
          }
      }
      if (asLink && hasLink) {
        t3 = <AppLink link={props.link} className={commonClassName}>{variantComponent}</AppLink>;
        break bb0;
      }
      const isDisabled = asLink && !hasLink;
      if ($[25] !== isDisabled) {
        t1 = isDisabled && {
          role: "group",
          "aria-disabled": true
        };
        $[25] = isDisabled;
        $[26] = t1;
      } else {
        t1 = $[26];
      }
      t2 = cn(commonClassName, isDisabled && "cursor-default", !asLink && "flex relative flex-row items-center gap-1 justify-center cursor-pointer");
    }
    $[5] = asLink;
    $[6] = className;
    $[7] = hasLink;
    $[8] = props.link;
    $[9] = tileParams;
    $[10] = variant;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = variantComponent;
  } else {
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    variantComponent = $[14];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[27] !== t1 || $[28] !== t2 || $[29] !== variantComponent) {
    t4 = <div {...t1} className={t2}>{variantComponent}</div>;
    $[27] = t1;
    $[28] = t2;
    $[29] = variantComponent;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  return t4;
}